import { useCallback, useMemo, useState } from 'react';
import type { CoinbaseProfileMenuResource } from '@cbhq/identity-api-hooks/profile-menu/types';

type UseResourceSearchParams = {
  resources: CoinbaseProfileMenuResource[] | undefined;
  activeResourceId: string | undefined;
};

export function useResourceSearch({ resources }: UseResourceSearchParams) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = useCallback((value: string) => {
    setSearchQuery(value);
  }, []);

  const searchFilteredResources = useMemo(() => {
    if (!searchQuery || !resources) {
      return resources;
    }

    return resources.filter((resource) =>
      resource.name?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [resources, searchQuery]);

  const shouldShowSearch = (resources?.length ?? 0) > 5;

  return {
    searchQuery,
    handleSearchChange,
    searchFilteredResources,
    shouldShowSearch,
  };
}
